<script lang="ts">
    import { createEventDispatcher } from 'svelte'

    export let value: string = ''
    export let inputType: 'text' | 'password' | 'tel' | 'search' = 'text'
    export let disabled = false
    export let required = false
    export let autocomplete: string = null
    // name/id do input nativo: só o login precisa deles hoje, para o gerenciador de senhas do
    // navegador reconhecer o par usuário/senha e oferecer o preenchimento
    export let name: string = null
    export let id: string = null
    // limite de caracteres (UF, sigla, código): vale para os tipos de texto
    export let maxlength: number = null
    export let labeled = false
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    function onKeyup(ev) {
        dispatch('keyup', ev)
    }
    function onChange(ev) {
        dispatch('change', ev)
    }
    function onFocus(ev) {
        dispatch('focus', ev)
    }
    function onBlur(ev) {
        dispatch('blur', ev)
    }
</script>

<input
    {autocomplete}
    {name}
    {id}
    {required}
    {maxlength}
    bind:this={htmlInput}
    type={inputType}
    class="zinput_input zinput_input_labeled-{labeled}"
    value={value}
    on:input={(ev) => (value = ev.currentTarget.value)}
    {disabled}
    on:keyup={onKeyup}
    on:change={onChange}
    on:focus={onFocus}
    on:blur={onBlur}
/>
